/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../onboard/business/categories';
import '../../onboard/business/subcategories';
import './common';
import '../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboarding": {
        "nested": {
          "business": {
            "nested": {
              "FrBusiness": {
                "fields": {
                  "category": {
                    "type": ".squareup.onboard.business.categories.BusinessCategory",
                    "id": 1,
                    "rule": "optional"
                  },
                  "subCategory": {
                    "type": ".squareup.onboard.business.subcategories.BusinessSubcategory",
                    "id": 2,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "addressToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "websiteUrl": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "vat": {
                    "type": ".squareup.onboarding.business.common.Vat",
                    "id": 7,
                    "rule": "optional"
                  },
                  "siretNumber": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "merchantAnalytic": {
                    "type": ".squareup.onboarding.business.common.MerchantAnalytic",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "enteredBeneficialOwnerInformation": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "nafCode": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "rcsNumber": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "countryOfRegistration": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "sharesCapital": {
                    "type": ".squareup.common.Money",
                    "id": 14,
                    "rule": "optional"
                  },
                  "tradingName": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboarding?.nested?.business?.nested?.FrBusiness) {
  $root.addJSON(jsonData);
}

/**
 * Represents a business entity in France.
 *
 * SOURCE FrBusiness @ squareup/onboarding/business/fr.proto at 15:1
 */
export const FrBusiness = $root.lookupType('squareup.onboarding.business.FrBusiness');
fixType(FrBusiness);
Builder.createAndAttachToType(FrBusiness);